"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _filter = _interopRequireDefault(require("../../icons/filter.svg"));
var _search = _interopRequireDefault(require("../../icons/search.svg"));
var _GroupFilterModule = _interopRequireDefault(require("../../styles/components/GroupCharts/GroupFilter.module.css"));
var _paulCorePackage = require("paul-core-package");
var _Clear = _interopRequireDefault(require("@mui/icons-material/Clear"));
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
var _function = require("../../utils/function");
var _constants = require("../../utils/constants");
var _devices = require("../../redux/actions/devices");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GroupFilter = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    chartId,
    equipmentKey
  } = _ref;
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const [searchedValue, setSearchedValue] = (0, _react.useState)("");
  const [radioValue, setRadioValue] = (0, _react.useState)("");
  const [radioItems, setRadioItems] = (0, _react.useState)([]);
  const [originalItems, setOriginalItems] = (0, _react.useState)([]);
  const open = Boolean(anchorEl);
  const dispatch = (0, _reactRedux.useDispatch)();
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const {
    [23]: tGroup = ""
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations, _paulCorePackage.functions.areEqual);
  const activeGroup = (0, _reactRedux.useSelector)((0, _selectors.selectActiveGroup)(chartId), _paulCorePackage.functions.areEqual);
  const groupListPwh = Object.values((0, _reactRedux.useSelector)(_selectors.selectPwhCList, _paulCorePackage.functions.areEqual));
  const groupListHx = Object.values((0, _reactRedux.useSelector)(_selectors.selectHxList, _paulCorePackage.functions.areEqual));
  const groupList = equipmentKey === _constants.keysForGroupChartsById.Pwh ? groupListPwh : groupListHx;
  const handleClick = (0, _react.useCallback)(e => setAnchorEl(e.currentTarget), []);
  const handleClose = (0, _react.useCallback)(() => setAnchorEl(null), []);
  const handleChangeRadio = (0, _react.useCallback)((_, newValue) => {
    setRadioValue(newValue);
    const activeGroup = (groupList === null || groupList === void 0 ? void 0 : groupList.find(item => item.id === newValue)) || null;
    dispatch((0, _devices.setActiveGroup)({
      chartId,
      equipmentKey,
      group: activeGroup
    }));
  }, [groupList, dispatch, chartId, equipmentKey]);
  const requestSearch = (0, _react.useCallback)(searchedVal => {
    setSearchedValue(searchedVal);
    const filteredItems = originalItems.filter(item => {
      return item["label"].toLowerCase().includes(searchedVal.toLowerCase());
    });
    setRadioItems(filteredItems);
  }, [originalItems]);
  const cancelSearch = (0, _react.useCallback)(() => {
    setSearchedValue("");
    requestSearch("");
  }, []);
  (0, _react.useEffect)(() => {
    let radioItemList = [];
    groupList === null || groupList === void 0 || groupList.map((group, index) => {
      radioItemList.push({
        value: group.id,
        label: (0, _function.getGroupName)({
          tGroup,
          name: tV(group === null || group === void 0 ? void 0 : group.thingInfoDesignation),
          index
        })
      });
    });
    setRadioItems(radioItemList);
    setOriginalItems(radioItemList);
  }, [groupList.length, tV, tGroup]);
  (0, _react.useEffect)(() => {
    setRadioValue(activeGroup);
  }, [activeGroup]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "text",
    "aria-controls": open ? "Device-table-filter" : undefined,
    "aria-expanded": open ? "true" : undefined,
    onClick: handleClick,
    className: _GroupFilterModule.default.button
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _filter.default,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement(_material.Popover, {
    id: "Device-table-filter",
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    PaperProps: {
      style: {
        backgroundColor: "transparent",
        boxShadow: "none",
        borderRadius: 0
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _GroupFilterModule.default.popover_container
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    id: "outlined-search",
    variant: "outlined",
    placeholder: "Search Groups..",
    type: "search",
    fullWidth: true,
    onChange: e => requestSearch(e.target.value),
    value: searchedValue,
    sx: {
      "& legend": {
        display: "none"
      },
      "& fieldset": {
        top: 0
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 0,
        background: "#FFFFFF",
        fontFamily: "var(--main-font-family) !important",
        padding: 0,
        "& fieldset": {
          border: "1px solid #C0C0CF"
        },
        "&:hover fieldset": {
          border: "1px solid #C0C0CF"
        },
        "&.Mui-focused fieldset": {
          border: "1px solid #C0C0CF"
        }
      },
      padding: "8px"
    },
    InputProps: {
      endAdornment: /*#__PURE__*/_react.default.createElement(_material.IconButton, {
        onClick: cancelSearch,
        disabled: !searchedValue
      }, searchedValue ? /*#__PURE__*/_react.default.createElement(_Clear.default, null) : /*#__PURE__*/_react.default.createElement("img", {
        src: _search.default,
        alt: ""
      }))
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    elevation: 0,
    style: {
      maxHeight: 287,
      overflow: "auto",
      backgroundColor: "transparent"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    className: "w-100 ".concat(_GroupFilterModule.default.radio_group_container)
  }, /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    "aria-labelledby": "demo-controlled-radio-buttons-group",
    name: "controlled-radio-buttons-group",
    value: radioValue,
    onChange: handleChangeRadio
  }, radioItems.map(radio => /*#__PURE__*/_react.default.createElement(_paulCorePackage.RadioItem, {
    value: radio.value,
    labelPlacement: "end",
    label: radio.label,
    type: "RadioListItem",
    key: radio.value + "RadioListItem",
    disabled: radio.disabled || false
  }))))))));
});
var _default = exports.default = GroupFilter;